import Accordion from 'accordion-js';

import '../css/FAQ-Section.css';

new Accordion('.accordion-container', {
  duration: 300,
  showMultiple: false,
});
